export const generic = {
    gen2: 2
  };
  